import type { LocationQuery, LocationQueryValue } from 'vue-router'

/** Query keys owned by the collection runtime — never treated as embedded data. */
const RESERVED_QUERY_KEYS = new Set(['rt', 'fresh'])

export function firstQueryString(value?: LocationQueryValue | LocationQueryValue[]): string | undefined {
  if (!value) return undefined

  const candidate = Array.isArray(value) ? value[0] : value

  if (typeof candidate !== 'string') return undefined

  const trimmed = candidate.trim()

  return trimmed.length > 0 ? trimmed : undefined
}

/**
 * Pull allowed embedded-data values from the collect URL query.
 *
 * Runtime returns `embedded_data_keys` for the published version; only those keys
 * are forwarded on session open. Reserved params (`rt`, `fresh`) are never included.
 * Values stay strings — BE coerces from the schema's `value_type`.
 */
export function collectEmbeddedData(query: LocationQuery, knownKeys: string[]): Record<string, string> | undefined {
  const embedded: Record<string, string> = {}

  for (const key of knownKeys) {
    if (!key || RESERVED_QUERY_KEYS.has(key)) continue

    const value = firstQueryString(query[key])

    if (value !== undefined) embedded[key] = value
  }

  return Object.keys(embedded).length > 0 ? embedded : undefined
}
